import { createReducer } from '../../utils/redux';
import {
  FLASH_MESSAGE,
  FLASH_MESSAGE_RESET,
} from './types';

const initialState = {
  message: null,
  show: false,
  type: '',
  autoHideDuration: 5000,
};

export default createReducer(initialState, {
  [FLASH_MESSAGE]: (state, payload) => (
    Object.assign({}, state, {
      message: payload.message,
      show: payload.show,
      type: payload.type,
      autoHideDuration: payload.autoHideDuration,
    })
  ),
  [FLASH_MESSAGE_RESET]: () => (
    Object.assign({}, initialState)
  ),
});



// WEBPACK FOOTER //
// ./src/redux/flash/reducers.js